import {
  Button,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Select,
  Table,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  LockOutlined,
  MinusSquareOutlined,
  PlusSquareOutlined,
} from '@ant-design/icons';
import colors from '../../../constants/ColourConstants';
import { useContext, useEffect, useState } from 'react';
import { getInvoiceByTransactionId } from "../../../services/TransactionApi's";
import AuditLogs from '../AuditLogs/AuditLogsPopup';
import CustomButton from '../../common/Button/Button';
import { CountryContext } from '../../common/Navigation/Navigation';
import FileSize from '../../../constants/FileSize';
import { handlePayoutPeriod } from '../../../utils/helpers/helper';

export default function TransactionsTable({
  transactions,
  loading,
  TableHeader = () => <> </>,
  handleRowSelection,
  handleRowStatusUpdate,
  selectedRowKeys,
  handleSort,
  sortField,
}) {
  const { Text } = Typography;

  const [editableRows, setEditableRows] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [invoiceData, setInvoiceData] = useState({});
  const [loadingInvoiceData, setLoadingInvoiceData] = useState(false);
  const [auditData, setAuditData] = useState({});
  const [editedValues, setEditedValues] = useState({});

  const { countries } = useContext(CountryContext);

  useEffect(() => {
    setEditableRows([]);
  }, [transactions]);

  const getFlag = (country) => {
    const countryObj = countries.find((c) => c.key === country);
    return countryObj
      ? `https://flagcdn.com/w40/${countryObj?.iso?.toLowerCase()}.png`
      : '';
  };

  const scroll = { y: 'calc(100vh - 300px)', x: '100vw' };

  const tableProps = {
    bordered: true,
    title: TableHeader,
    scroll,
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'transactionId',
      width: 98,
      render: (value, record) => {
        const { isLocked, striked } = record;
        return (
          <Tooltip
            title={
              <>
                {value} {isLocked && <LockOutlined />}
              </>
            }
          >
            <Typography.Text
              delete={striked}
              style={{
                width: 80,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
                color: colors.colorPrimary,
              }}
            >
              <AuditLogs
                recordId={value}
                from="transactions"
                auditData={auditData[`${value}`]}
                setTransactionsAuditData={setAuditData}
              >
                {value}
                {isLocked && <LockOutlined style={{ marginLeft: 8 }} />}
              </AuditLogs>
            </Typography.Text>
          </Tooltip>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'ids' ? sortField?.order : null,
    },
    {
      title: 'Type',
      dataIndex: 'transactionType',
      width: 155,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Category',
      dataIndex: 'category',
      width: 200,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      title: 'CP ID',
      dataIndex: 'contributorProjectId',
      width: 320,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              width: 300,
              display: 'block',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Contributor',
      dataIndex: 'contributorEmail',
      width: 300,
      render: (text, record) => (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {record.country && (
            <img
              src={getFlag(record?.country)}
              alt={record.country}
              style={{ width: 24, height: 16, marginRight: 8, borderRadius: 4 }}
            />
          )}
          <Tooltip title={`(${record.country || ' - '}) ${text}`}>
            <Typography.Text
              delete={record.striked}
              style={{
                width: 300,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: record.striked
                  ? colors.colorTextTertiary
                  : colors.colorText,
              }}
            >
              {text}
            </Typography.Text>
          </Tooltip>
        </span>
      ),
    },
    {
      title: 'PayRate',
      dataIndex: 'payRate',
      width: 130,
      render: (value, record) => {
        const { striked, transactionId } = record;
        // return editableRows.includes(transactionId) ? (
        //   <>
        //     <Form style={{ display: 'flex', float: 'right' }}>
        //       <Form.Item
        //         name="status"
        //         style={{
        //           width: '65%',
        //           margin: 0,
        //         }}
        //       >
        //         <InputNumber
        //           size="small"
        //           min={0}
        //           placeholder="Enter Value"
        //           style={{ width: '90px' }}
        //           width={90}
        //           defaultValue={value}
        //           onChange={(val) => {
        //             setEditedValues((prev) => ({
        //               [transactionId]: {
        //                 ...(prev[transactionId] || {}),
        //                 updatedPayRate: val,
        //               },
        //             }));
        //           }}
        //         />
        //       </Form.Item>
        //     </Form>
        //   </>
        // ) : (
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                float: 'right',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value != null ? `$ ${value.toFixed(2)}` : 'N/A'}
            </Typography.Text>
          </Tooltip>
        );
        // );
      },
      sorter: true,
      sortOrder: sortField?.field === 'payRates' ? sortField?.order : null,
    },
    {
      title: 'Hours',
      dataIndex: 'hours',
      width: 130,
      // render: (value, record) => {
      //   const { striked } = record;
      //   return (
      //     <Typography.Text
      //       delete={striked}
      //       style={{
      //         color: striked ? colors.colorTextTertiary : colors.colorText,
      //       }}
      //     >
      //       {value}
      //     </Typography.Text>
      //   );
      // },
      render: (value, record) => {
        const { striked, transactionId } = record;
        // return editableRows.includes(transactionId) ? (
        //   <>
        //     <Form style={{ display: 'flex', float: 'right' }}>
        //       <Form.Item
        //         name="hours"
        //         style={{
        //           width: '65%',
        //           margin: 0,
        //         }}
        //       >
        //         <InputNumber
        //           size="small"
        //           min={0}
        //           disabled={record.units || editedValues.updatedUnits}
        //           placeholder="Enter Value"
        //           style={{ width: '90px' }}
        //           width={90}
        //           defaultValue={value}
        //           onChange={(val) => {
        //             setEditedValues((prev) => ({
        //               [transactionId]: {
        //                 ...(prev[transactionId] || {}),
        //                 updatedHours: val,
        //               },
        //             }));
        //           }}
        //         />
        //       </Form.Item>
        //     </Form>
        //   </>
        // ) : (
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                float: 'right',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value != null ? value : 'N/A'}
            </Typography.Text>
          </Tooltip>
        );
        // );
      },
      sorter: true,
      sortOrder: sortField?.field === 'hour' ? sortField?.order : null,
    },
    {
      title: 'Units',
      dataIndex: 'units',
      width: 130,
      // render: (value, record) => {
      //   const { striked } = record;
      //   return (
      //     <Typography.Text
      //       delete={striked}
      //       style={{
      //         color: striked ? colors.colorTextTertiary : colors.colorText,
      //       }}
      //     >
      //       {value}
      //     </Typography.Text>
      //   );
      // },
      render: (value, record) => {
        const { striked, transactionId } = record;
        // return editableRows.includes(transactionId) ? (
        //   <>
        //     <Form style={{ display: 'flex', float: 'right' }}>
        //       <Form.Item
        //         name="units"
        //         style={{
        //           width: '65%',
        //           margin: 0,
        //         }}
        //       >
        //         <InputNumber
        //           size="small"
        //           min={0}
        //           disabled={record.hours || editedValues.updatedHours}
        //           placeholder="Enter Value"
        //           style={{ width: '90px' }}
        //           width={90}
        //           defaultValue={value}
        //           onChange={(val) => {
        //             setEditedValues((prev) => ({
        //               [transactionId]: {
        //                 ...(prev[transactionId] || {}),
        //                 updatedUnits: val,
        //               },
        //             }));
        //           }}
        //         />
        //       </Form.Item>
        //     </Form>
        //   </>
        // ) : (
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                float: 'right',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value != null ? value : 'N/A'}
            </Typography.Text>
          </Tooltip>
        );
        // );
      },
      sorter: true,
      sortOrder: sortField?.field === 'unit' ? sortField?.order : null,
    },
    {
      title: 'Amount',
      dataIndex: 'transactionAmount',
      width: 100,
      render: (value, record) => {
        const { transactionId, striked, payRate, hours, units } = record;
        const _payRate = editedValues[transactionId]?.updatedPayRate || payRate;
        const _hours = editedValues[transactionId]?.updatedHours || hours;
        const _units = editedValues[transactionId]?.updatedUnits || units;
        const total = _hours ? _payRate * _hours : _payRate * _units;

        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
              float: 'right',
            }}
          >
            {value.toFixed(2)}
            {/* ${" "}
             {editableRows.includes(transactionId)
              ? total.toFixed(2)
              : value.toFixed(2)} */}
          </Typography.Text>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'amounts' ? sortField?.order : null,
    },
    {
      title: 'Transaction Date',
      dataIndex: 'transactionDate',
      width: 159,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
      sorter: true,
      sortOrder:
        sortField?.field === 'transactionDates' ? sortField?.order : null,
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      width: 159,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'createdDates' ? sortField?.order : null,
    },
    {
      title: 'Last Modified Date',
      dataIndex: 'modifiedDate',
      width: 170,
      render: (value, record) => {
        const { striked } = record;

        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'modifiedDates' ? sortField?.order : null,
    },
    {
      title: 'Status',
      dataIndex: 'transactionStatus',
      width: 260,
      render: (value, record) => {
        const { statusVarient, isLocked, transactionId } = record;
        return editableRows.includes(transactionId) ? (
          <>
            <Form style={{ display: 'flex' }}>
              <Form.Item
                name="status"
                style={{ width: '65%', margin: 0, marginRight: 12 }}
              >
                <Select
                  placeholder="Select status"
                  defaultValue={value}
                  onChange={(val) => {
                    setEditedValues((prev) => ({
                      [transactionId]: {
                        ...(prev[transactionId] || {}),
                        updatedStatus: val,
                      },
                    }));
                  }}
                >
                  <Radio value={'Ready for Invoice'}>Ready for Invoice</Radio>
                  <Radio value={'Under Further Review'}>
                    Under Further Review
                  </Radio>
                  <Radio value={'Voided'}>Voided</Radio>
                </Select>
              </Form.Item>
            </Form>
          </>
        ) : (
          <Tooltip title={value}>
            {!isLocked ? (
              <Typography.Text
                // onMouseEnter={(e) =>
                //   (e.currentTarget.children.namedItem(
                //     'tb-edit-icon',
                //   ).style.display = 'inline-flex')
                // }
                // onMouseLeave={(e) =>
                //   (e.currentTarget.children.namedItem(
                //     'tb-edit-icon',
                //   ).style.display = 'none')
                // }
                style={{
                  width: 220,
                  display: 'block',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                <Tag color={statusVarient}>{value}</Tag>
                {/* <EditOutlined
                  name="tb-edit-icon"
                  style={{
                    display: 'none',
                    cursor: 'pointer',
                    color: colors.colorPrimary,
                  }}
                  onClick={() => setEditableRows([record.transactionId])}
                /> */}
              </Typography.Text>
            ) : (
              <Typography.Text
                style={{
                  width: 220,
                  display: 'block',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                <Tag color={statusVarient}>{value}</Tag>
              </Typography.Text>
            )}
          </Tooltip>
        );
      },
    },
    {
      title: 'Invoice Period',
      dataIndex: 'invoicePeriod',
      key: 'invoicePeriod',
      width: 160,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Text
            delete={record.striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value ? handlePayoutPeriod(value) : value}
          </Text>
        );
      },
    },
    {
      title: 'Workday ID',
      dataIndex: 'workdayId',
      width: 159,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Project Name',
      dataIndex: 'projectName',
      width: 250,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                width: 220,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value}
            </Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'PO Name',
      dataIndex: 'projectObjectiveName',
      width: 250,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                width: 220,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value}
            </Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'PO Country',
      dataIndex: 'POCountry',
      width: 210,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                width: 180,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value}
            </Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'PO Language',
      dataIndex: 'POLanguage',
      width: 210,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Tooltip title={value}>
            <Typography.Text
              delete={striked}
              style={{
                width: 180,
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                color: striked ? colors.colorTextTertiary : colors.colorText,
              }}
            >
              {value}
            </Typography.Text>
          </Tooltip>
        );
      },
    },
    // {
    //   title: 'Notes',
    //   dataIndex: 'notes',
    //   width: 250,
    //   render: (value, record) => {
    //     const { striked, transactionId } = record;
    //     return editableRows.includes(transactionId) ? (
    //       <>
    //         <Form style={{ display: 'flex' }}>
    //           <Form.Item
    //             name="notes"
    //             style={{
    //               width: '65%',
    //               margin: 0,
    //             }}
    //           >
    //             <Input
    //               placeholder="Please enter"
    //               style={{ width: '200px' }}
    //               maxLength={64}
    //               showCount
    //               width={200}
    //               defaultValue={value}
    //               onChange={(e) => {
    //                 setEditedValues((prev) => ({
    //                   [transactionId]: {
    //                     ...(prev[transactionId] || {}),
    //                     updateNotes: e.target.value,
    //                   },
    //                 }));
    //               }}
    //             />
    //           </Form.Item>
    //         </Form>
    //       </>
    //     ) : (
    //       <Tooltip title={value}>
    //         <Typography.Text
    //           delete={striked}
    //           style={{
    //             color: striked ? colors.colorTextTertiary : colors.colorText,
    //           }}
    //         >
    //           {value != null ? value : ''}
    //         </Typography.Text>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      title: 'Invoice ID',
      dataIndex: 'invoiceId',
      key: 'invoice_id',
      width: 200,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Payout ID',
      dataIndex: 'payoutId',
      key: 'payout_id',
      width: 200,
      render: (value, record) => {
        const { striked } = record;
        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Payout Created',
      dataIndex: 'payoutCreatedDate',
      key: 'created_date',
      width: 160,
      render: (value, record) => {
        const { striked } = record;

        return (
          <Typography.Text
            delete={striked}
            style={{
              color: striked ? colors.colorTextTertiary : colors.colorText,
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },

    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 80,
      render: (record) => {
        const { transactionId, isLocked } = record;
        return editableRows.includes(transactionId) ? (
          <div style={{ display: 'flex' }}>
            <CustomButton
              htmlType="reset"
              type="primary"
              variant="text"
              icon={<CloseOutlined />}
              onClick={() => {
                setEditableRows([]);
                setEditedValues({});
              }}
              size="middle"
              shape="circle"
            />
            <CustomButton
              htmlType="submit"
              type="primary"
              variant="text"
              icon={<CheckOutlined />}
              onClick={() => {
                handleRowStatusUpdate(
                  'single',
                  transactionId,
                  editedValues[transactionId]?.updatedStatus,
                );
              }}
              size="middle"
              shape="circle"
            />
          </div>
        ) : (
          <EditOutlined
            style={
              isLocked
                ? {
                    pointerEvents: 'none',
                    opacity: 0.5,
                    cursor: 'not-allowed',
                    marginLeft: 8,
                  }
                : {
                    cursor: 'pointer',
                    color: colors.colorPrimary,
                    marginLeft: 8,
                  }
            }
            onClick={() => setEditableRows([record.transactionId])}
          />
        );
      },
    },
  ];

  const handleExpandRow = async (expanded, record) => {
    if (expanded) {
      if (!invoiceData[`${record.transactionId}`]) {
        setLoadingInvoiceData(true);
        try {
          const res = await getInvoiceByTransactionId(record.transactionId);
          setInvoiceData((prev) => ({
            ...prev,
            [`${record.transactionId}`]: res,
          }));
        } catch {
          message.error('Failed to fetch invoice data');
        } finally {
          setLoadingInvoiceData(false);
        }
      }
      setExpandedRowKeys((prev) => [...prev, record.transactionId]);
    } else {
      setExpandedRowKeys((prev) =>
        prev.filter((key) => key !== record.transactionId),
      );
    }
  };
  const handleTableChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    handleSort({ field, order });
  };

  return (
    <>
      <Table
        {...tableProps}
        rowSelection={{
          preserveSelectedRowKeys: true,
          fixed: true,
          // getCheckboxProps: (record) => ({
          //   disabled: record.isLocked,
          // }),
          // onChange: (selectedRowKeys, selectedRecords, info) =>
          //   handleRowSelection(selectedRowKeys, selectedRecords, info),

          onChange: (selectedRowKeys, selectedRecords, info) => {
            if (selectedRowKeys.length >= FileSize.SELECT_SIZE) {
              message.warning('You can select up to 30,000 rows only.');
            }
            handleRowSelection(selectedRowKeys, selectedRecords, info);
          },
          getCheckboxProps: (record) => {
            const isSelected = selectedRowKeys.includes(record.key);
            const disable =
              !isSelected && selectedRowKeys.length >= FileSize.SELECT_SIZE;

            return {
              disabled: disable || record.isLocked,
            };
          },
          renderCell: (checked, record, index, originNode) => {
            if (record.isLocked) {
              const isExpanded = expandedRowKeys.includes(record.transactionId);
              return isExpanded ? (
                <MinusSquareOutlined
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExpandRow(false, record);
                  }}
                />
              ) : (
                <PlusSquareOutlined
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExpandRow(true, record);
                  }}
                />
              );
            }
            return originNode;
          },
        }}
        expandable={{
          showExpandColumn: false,
          rowExpandable: (record) => record.isLocked,
          expandedRowRender: (record) => {
            return (
              <div
                style={{
                  margin: '0 32px',
                  borderRadius: 6,
                  padding: 8,
                  border: `1px solid ${colors.colorBorder}`,
                }}
              >
                <Text>
                  <Text>
                    INVOICE ID:{' '}
                    <Text style={{ color: colors.colorPrimary }}>
                      {invoiceData[`${record.transactionId}`]?.invoiceId || '-'}
                    </Text>
                  </Text>
                  &emsp; | &emsp;
                  <Text>
                    Status:{' '}
                    <Text>
                      {invoiceData[`${record.transactionId}`]?.status || '-'}
                    </Text>
                  </Text>
                  &emsp; | &emsp;
                  <Text>
                    Total Amount:{' '}
                    <Text>
                      {invoiceData[`${record.transactionId}`]?.amount
                        ? `$${invoiceData[`${record.transactionId}`]?.amount}`
                        : '-'}
                    </Text>
                  </Text>
                </Text>
              </div>
            );
          },
          onExpand: () => {},
          expandedRowKeys: expandedRowKeys,
        }}
        pagination={false}
        style={{ marginBottom: 0 }}
        loading={loading || loadingInvoiceData}
        columns={columns}
        onChange={handleTableChange}
        dataSource={transactions}
        scroll={scroll}
        size="large"
      />
    </>
  );
}
